import { DsbcApiOptions } from '../_dsapi/DsbcApiOptions';
import { createDsbcApiUrl } from '../createDsbcApiUrl';
import { DsbcApi } from '../createDsbcRequest';
import { BaseRequest, BaseResponse } from '../shared';

interface getMonthRwdListRequest extends BaseRequest {
  invId: string; //邀请活动ID ,
}

export interface InvMonthDataVO {
  getNote?: string; //领取提示，0-则无弹窗，1-可以弹窗 ,  ,
  rewardIndex?: string; //月份，格式yyyyMM ,
  rewardValue?: string; //奖励值，给对应的金额
}

interface getMonthRwdListResponse extends BaseResponse {
  Data: InvMonthDataVO[];
}

/**
 * POST /inv/getMonthRwdList
获取邀新月榜的奖励列表，需要传入邀新活动ID
 * @param params
 * @returns
 */
export async function getMonthRwdList(request: getMonthRwdListRequest, options?: DsbcApiOptions) {
  const url = await createDsbcApiUrl('/inv/getMonthRwdList');
  return DsbcApi.fetch<getMonthRwdListResponse>(url, request, true, options);
}
